import { Component, OnInit, ViewChild, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { DatePipe } from '@angular/common';

import { EquipmentDetailService } from '../equipment-detail';
import { EquipmentEditService } from './equipment-edit.service';
import { Equipment } from './../../../../model';

import { SiteSummaryService } from '../../site';
import { ProductCategorySummaryService } from '../../product-category';
import { IsActive } from './../../../../model';
import { IOption } from 'ng-select';

import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { OWL_datetime_formats } from './../../owl_datetime_formats';
import { EquipmentSummaryService } from '../equipment-summary/equipment-summary.service';

@Component({
  selector: 'app-equipment-edit',
  templateUrl: './equipment-edit.component.html',
  styleUrls: [
    '../../../../../scss/vendors/ng-select/ng-select.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats},
  ],
})
export class EquipmentEditComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;
  @ViewChild('successModal') successModal: any;

  equipmentId = '';
  equipment: any;
  // model = new Equipment('', '', '', '', '', '', [], [], '', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, 0);
  redirect = true;

  editEquipmentForm: FormGroup;

  customerShortName: String = '';
  customerName: String = '';
  locationShortName: String = '';
  endUser: String = '';
  productCategory: Array<any> = [];
  brand: String = '';
  model: String = '';
  designationNumber: String = '';
  productName: String = '';
  serialNumber: String = '';
  description: String = '';
  type: String = '';
  ratingOrCapacity: String = '';
  // remarks: String = '';

  sites: any[];
  siteOptions: Array<IOption> = [];
  selectedSiteId: String = '';

  productCats = [];
  forms = [];

  dropdownSettings = {};
  formDropdownSettings = {};
  // selectedProductCategory: any;
  productCategoryNotFilled: Boolean;
  // productCatOptions: Array<IOption> = [];

  jobs: any[];
  dataTable: any;

  selectedJob;

  job: any;
  inputFSED;
  inputCSD;
  inputCED;
  public largeModal;

  editJobForm: FormGroup;

  batteryQuantity: String = '';
  batteryBrand: String = '';
  batteryModel: String = '';
  // fireServiceExpiryDate: Date;
  fireServiceExpiryDate: String = '';
  spareParts: String = '';
  vendorOrSubcontractor: String = '';
  contractStartDate: Date;
  contractEndDate: Date;
  ecall: String = '';
  remarks: String = '';

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private equipmentSummaryService: EquipmentSummaryService,
    private equipmentDetailService: EquipmentDetailService,
    private equipmentEditService: EquipmentEditService,
    private siteSummaryService: SiteSummaryService,
    private productCategorySummaryService: ProductCategorySummaryService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.equipmentId = params['id'];
    });
    this.createEditEquipmentForm();
  }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      text: 'Select Product Category',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'name'
    };

    this.formDropdownSettings = {
      singleSelection: false,
      text: 'Select Form',
      enableSearchFilter: true,
      labelKey: 'name'
    };

    this.productCategoryNotFilled = false;


    this.getSiteSummary();
    this.getDetail();
    this.getProductCategorySummary();
    this.getJobSummary();
    this.getForms();
  }


  createEditEquipmentForm() {
    this.editEquipmentForm = this.formBuilder.group({
      customerShortName: new FormControl('', [
      ]),
      customerName: new FormControl('', [
      ]),
      locationShortName: new FormControl('', [
      ]),
      siteId: new FormControl(''),
      endUser: new FormControl('', [
      ]),
      productCategory: new FormControl('', [
        Validators.required
      ]),
      brand: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      model: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      designationNumber: new FormControl('', [
        Validators.required,
        Validators.maxLength(100)
      ]),
      productName: new FormControl('', [
        Validators.maxLength(100)
      ]),
      serialNumber: new FormControl('', [
        Validators.maxLength(100)
      ]),
      description: new FormControl('', [
        Validators.maxLength(100)
      ]),
      type: new FormControl('', [
        Validators.maxLength(100)
      ]),
      ratingOrCapacity: new FormControl('', [
        Validators.maxLength(100)
      ]),
      forms: new FormControl([]),
      // remarks: new FormControl('', [
      //   Validators.maxLength(1000)
      // ])
    });
  }

  editEquipment(editEquipmentForm) {
    this.equipmentEditService
      .edit(this.equipmentId, editEquipmentForm.controls, this.equipment.remarks)
      .subscribe(
        data => {
          if (data) {
            // this.model = data;
            // this.model.formodel = data.model;
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  getDetail() {
    this.equipmentDetailService
      .getDetail(this.equipmentId)
      .subscribe(
        data => {
          if (data) {
            // this.model = data;
            // this.model.formodel = data.model;
            this.equipment = data;
            this.editEquipmentForm.patchValue({
              customerShortName: this.equipment.customerShortName,
              customerName: this.equipment.customerName,
              siteId: this.equipment.siteId+'',
              locationShortName: this.equipment.locationShortName,
              endUser: this.equipment.endUser,
              productCategory: [{ 'id': this.equipment.prodCategoryId, 'name': this.equipment.prodCategory }],
              brand: this.equipment.brand,
              model: this.equipment.model,
              designationNumber: this.equipment.designationNumber,
              productName: this.equipment.productName,
              serialNumber: this.equipment.serialNumber,
              description: this.equipment.description,
              type: this.equipment.type,
              ratingOrCapacity: this.equipment.ratingOrCapacity,
              forms: this.equipment.forms
              // remarks: this.equipment.remarks
            });


            // this.selectedProductCategory = [{'id': this.model.prodCategoryId, 'name': this.model.prodCategory}];
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }
  getForms() {
    this.equipmentSummaryService.getForms().subscribe(res => {
      this.forms = res.formListModel;
    });
  }
  getSiteSummary() {
    this.siteSummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
        const options = [];
        $.each(this.sites, function (k, v) {
          const option = {
            // using locationShort instead of location
            // because siteSummaryService seems cannot get location
            'label': v.locationShort,
            'value': v.id+''
          };
          options.push(option);
        });
        this.siteOptions = options;
        // this.selectedSiteId = '10004';
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        });
  }

  getProductCategorySummary() {
    this.productCategorySummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.productCats = data.productCatListModel;
        // const options = [];
        // $.each(this.productCats, function (k, v) {
        //   const option = {
        //     'label': v.name,
        //     'value': v.id
        //   };
        //   options.push(option);
        // });
        // this.productCatOptions = options;
        $('div.c-btn').attr('id', 'single-select');
      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
          this.redirect = true;
        });
  }

  getJobSummary() {
    this.equipmentDetailService
      .getJobSummary(this.equipmentId)
      .subscribe(
        data => {
          if ($.fn.dataTable.isDataTable('#jobDataTables')) { $('#jobDataTables').DataTable().destroy(); }
          this.jobs = data.equipmentByIdListModel;
          this.chRef.detectChanges();

          const table: any = $('#jobDataTables');
          this.dataTable = table.DataTable();
        },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        }
      );
  }

  onSelect(job): void {
    this.selectedJob = job;
    this.createEditJobForm();
    this.getJobDetail();
  }

  createEditJobForm() {
    this.editJobForm = this.formBuilder.group({
      batteryQuantity: new FormControl('', [
        Validators.maxLength(100)
      ]),
      batteryBrand: new FormControl('', [
        Validators.maxLength(100)
      ]),
      batteryModel: new FormControl('', [
        Validators.maxLength(100)
      ]),
      fireServiceExpiryDate: new FormControl([
        Validators.maxLength(300)
      ]),
      spareParts: new FormControl('', [
        Validators.maxLength(100)
      ]),
      vendorOrSubcontractor: new FormControl('', [
        Validators.maxLength(100)
      ]),
      contractStartDate: new FormControl([
        Validators.required
      ]),
      contractEndDate: new FormControl([
        Validators.required
      ]),
      ecall: new FormControl('', [
        Validators.maxLength(100)
      ]),
      remarks: new FormControl('', [
        Validators.maxLength(1000)
      ])
    });
  }

  editEquipmentJob(editJobForm: NgForm) {
    this.equipmentEditService
      .editJob(this.equipmentId, this.selectedJob.jobId, editJobForm.controls)
      .subscribe(
        data => {
          if (data) {
            // this.model = data;
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  getJobDetail() {
    this.equipmentDetailService
      .getJobDetail(this.equipmentId, this.selectedJob.jobId)
      .subscribe(
        data => {
          if (data) {
            this.job = data;

            this.editJobForm.setValue({
              batteryQuantity: this.job.batteryQuantity,
              batteryBrand: this.job.batteryBrand,
              batteryModel: this.job.batteryModel,
              // fireServiceExpiryDate: (this.job.fireServiceExpiryDate != null ? new Date(this.job.fireServiceExpiryDate) : null),
              fireServiceExpiryDate: this.job.fireServiceExpiryDate,
              spareParts: this.job.spareParts,
              vendorOrSubcontractor: this.job.vendorOrSubcontractor,
              contractStartDate: (this.job.contractStartDate != null ? new Date(this.job.contractStartDate) : null),
              contractEndDate: (this.job.contractEndDate != null ? new Date(this.job.contractEndDate) : null),
              ecall: this.job.ecall,
              remarks: this.job.remarks
            });
            // this.fireServiceExpiryDate = (this.job.fireServiceExpiryDate != null ? new Date(this.job.fireServiceExpiryDate) : null);
            this.fireServiceExpiryDate = this.job.fireServiceExpiryDate;
            this.contractStartDate = (this.job.contractStartDate != null ? new Date(this.job.contractStartDate) : null);
            this.contractEndDate = (this.job.contractEndDate != null ? new Date(this.job.contractEndDate) : null);
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }

  dateTimeChange(ele: any) {
    this.contractStartDate = this.editJobForm.controls['contractStartDate'].value;
    this.contractEndDate = this.editJobForm.controls['contractEndDate'].value;

    if (this.contractStartDate == null) {
      this.editJobForm.controls['contractStartDate'].setErrors({ 'required': true });
    }
    if (this.contractEndDate == null) {
      this.editJobForm.controls['contractEndDate'].setErrors({ 'required': true });
    }
  }

  reset() {
    this.successModal.hide();
    this.selectedJob = null;
    this.getJobSummary();
  }

  closeSuccessModel() {
    if (this.selectedJob) {
      this.reset();
    } else {
      this.router.navigate(['/home/equipment/detail/' + this.equipmentId]);
    }
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/equipment']);
    } else {
      this.dangerModal.hide();
    }
  }


  get siteId() { return this.editEquipmentForm.get('siteId')}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-edit/equipment-edit.component.ts